import LocalizedStrings from "react-localization";
import French from "../resources/lang.fr";
import English from "../resources/lang.en";

const strings = new LocalizedStrings({
    en: English,
    fr: French
});

/*export let lang = localStorage.getItem("lang");
if (!lang) {
    lang = strings.getInterfaceLanguage().indexOf("fr") > -1 ? "fr" : "en";
}*/
export const lang = "fr";

strings.setLanguage(lang);

export default strings;
